export default __webpack_public_path__ + "static/media/(7).bca7d30b.jpg";